import { Box } from '@mui/material';

import { Logo } from 'src/components/Logo';
import { useGetMyProfileQuery } from 'src/redux/api/user';

const MenuLogo = ({ small = false, withoutStyles = false }) => {
  const styles = small ? { display: 'flex', justifyContent: 'center', py: 2.5 } : { pl: 3.5, pt: 2.5, pb: 1 };
  const { data } = useGetMyProfileQuery();
  return (
    <Box sx={withoutStyles ? {} : styles}>
      {data?.company.logoUrl ? (
        <img alt="logo" src={data?.company.logoUrl} style={{ objectFit: 'scale-down' }} height="60px" />
      ) : (
        <Logo />
      )}
    </Box>
  );
};

export default MenuLogo;
